var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInstagramGradient = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 101,
    viewBox: "0 0 95 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.203125 30.739V70.4236C0.203179 72.2342 0.705648 74.0132 1.66005 75.5812C2.61445 77.1494 3.98717 78.4515 5.64021 79.357L41.8674 99.1992C43.5206 100.105 45.3958 100.581 47.3045 100.581C49.2135 100.581 51.0885 100.105 52.7416 99.1992L88.9689 79.357C90.6221 78.4515 91.9947 77.1494 92.9492 75.5812C93.9036 74.0132 94.406 72.2342 94.406 70.4236V30.739C94.406 28.9284 93.9036 27.1494 92.9492 25.5814C91.9947 24.0132 90.6221 22.711 88.9689 21.8056L52.7416 1.96333C51.0885 1.05795 49.2135 0.581299 47.3045 0.581299C45.3958 0.581299 43.5206 1.05795 41.8674 1.96333L5.64021 21.8056C3.98717 22.711 2.61445 24.0132 1.66005 25.5814C0.705648 27.1494 0.203179 28.9284 0.203125 30.739Z",
    fill: "#4375C5",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36853 74.5414L3.36846 74.5413C2.60202 73.2821 2.20317 71.8622 2.20312 70.4236V30.7391C2.20312 30.7391 2.20312 30.739 2.20312 30.739C2.20318 29.3004 2.60203 27.8805 3.36846 26.6213L3.36853 26.6212C4.13558 25.3608 5.24686 24.3014 6.60096 23.5597L5.64021 21.8056L6.60097 23.5597L42.8282 3.71749C44.1829 2.97553 45.7272 2.5813 47.3045 2.5813C48.8821 2.5813 50.4261 2.97552 51.7809 3.71749L88.0082 23.5597L88.0082 23.5598C89.3624 24.3014 90.4735 25.3607 91.2407 26.6212L91.2408 26.6214C92.0072 27.8804 92.406 29.3004 92.406 30.739V70.4236C92.406 71.8622 92.0072 73.2821 91.2408 74.5412L91.2407 74.5414C90.4736 75.8018 89.3624 76.8611 88.0082 77.6029L51.7809 97.4451C50.4262 98.1871 48.8822 98.5813 47.3045 98.5813C45.7271 98.5813 44.1829 98.1871 42.8282 97.4451L6.60103 77.6029C6.60101 77.6029 6.60099 77.6029 6.60097 77.6029C5.24681 76.8611 4.13555 75.8018 3.36853 74.5414Z",
    stroke: "url(#paint0_linear_13440_32910)",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7416 40.0867C54.7108 40.0867 53.877 40.9205 53.877 41.9513C53.877 42.9821 54.7108 43.8159 55.7416 43.8159C56.7723 43.8159 57.6062 42.9821 57.6062 41.9513C57.6062 40.9205 56.7723 40.0867 55.7416 40.0867Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4265 42.4841C43.095 42.4841 39.5742 46.0049 39.5742 50.3364C39.5742 54.6679 43.095 58.1887 47.4265 58.1887C51.758 58.1887 55.2788 54.6679 55.2788 50.3364C55.2788 46.0049 51.758 42.4841 47.4265 42.4841ZM47.4265 55.3628C44.6585 55.3628 42.4001 53.1044 42.4001 50.3364C42.4001 47.5684 44.6585 45.31 47.4265 45.31C50.1945 45.31 52.4529 47.5684 52.4529 50.3364C52.4529 53.1044 50.1945 55.3628 47.4265 55.3628Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6578 66.2726H40.9412C35.66 66.2726 31.3633 61.9759 31.3633 56.6947V43.9781C31.3633 38.6969 35.66 34.4001 40.9412 34.4001H53.6694C58.9506 34.4001 63.2473 38.6969 63.2473 43.9781V56.7062C63.2473 61.9874 58.9506 66.2842 53.6694 66.2842L53.6578 66.2726ZM40.9412 37.3998C37.3162 37.3998 34.3629 40.3531 34.3629 43.9781V56.7062C34.3629 60.3313 37.3162 63.2846 40.9412 63.2846H53.6694C57.2944 63.2846 60.2477 60.3313 60.2477 56.7062V43.9781C60.2477 40.3531 57.2944 37.3998 53.6694 37.3998H40.9412Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13440_32910",
    x1: 0.203123,
    y1: 0.342115,
    x2: 114.795,
    y2: 63.1305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#4195D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4195D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4195D2",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInstagramGradient);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/instagram_gradient.fb2fe869f23764a8cb94bb51dfa28ef0.svg";